import { render } from "./ai-global-tooltip.vue?vue&type=template&id=0a74b13e"
import script from "./ai-global-tooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-global-tooltip.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-global-tooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a74b13e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a74b13e', __exports__)) {
    api.reload('0a74b13e', __exports__)
  }
  
  module.hot.accept("./ai-global-tooltip.vue?vue&type=template&id=0a74b13e", () => {
    api.rerender('0a74b13e', render)
  })

}


export default __exports__